module.exports = __webpack_public_path__ + "img/arrowBtn.bac267cd.svg";